import {useState, useRef} from 'react';
import {Row, Col, Form, Button} from 'react-bootstrap'
import { iminioBackend } from '../../api/iminio_provider';
import i18n from '../../plugins/i18n';

function EditAdminForm({ listId, userData, reloadList, changeView }) {

    const [isLoading, setLoading] = useState(false);
    const [isEditing, setEditing] = useState(false);
    const [showError, setShowError] = useState('');
    const [showMessage, setShowMessage] = useState('');
    const [isDeleting, setDeleting] = useState(false);
    const [lastUserData, setLastUserData] = useState(userData);

    const firstnameField = useRef(null);
    const lastnameField = useRef('');
    const emailField = useRef('');
    const phoneField = useRef('');
    const notesField = useRef('');

    const validatePhone = (phone) => {
        phone = phone.replace('+','')
        phone = phone.replace(' ','')
        return !Number.isNaN(parseInt(phone))
    }

    const handleSubmitEdit = async () => {
        setLoading(true)
        setShowError("")
        try{
            if(
                validatePhone(phoneField?.current?.value)===false
                || phoneField?.current?.value.includes('\'')
                || phoneField?.current?.value.includes('`')
                || phoneField?.current?.value.includes('"')
                || phoneField?.current?.value.includes('p')
                || phoneField?.current?.value.includes('d')
                || phoneField?.current?.value.includes('e')
                || phoneField?.current?.value.includes('f')
            ){
                throw new Error()
            }
        }catch(e){
            console.log(e)
            setTimeout(()=>{
                setLoading(false)
                setShowError('Telefono é compilato erroneamente.')
            },300)
            return
        }
        const newUserData = {
            first_name: firstnameField.current.value,
            last_name: lastnameField.current.value,
            email: emailField.current.value,
            phone: phoneField.current.value,
            notes: notesField.current.value,
        }
        await iminioBackend.edit_admin_user(userData.id, newUserData).then(response=>{
            setLoading(false)
            setEditing(false)
            setShowMessage("Salvato con successo!")
            setTimeout(() => {
                setShowMessage("")
            }, 3100);
            setLastUserData(response)
            const elFullName = document.getElementById(`${listId}-full_name`)
            const elEmail = document.getElementById(`${listId}-email`)
            const elPhone = document.getElementById(`${listId}-phone`)
            elFullName.innerHTML=`${response.first_name} ${response.last_name}`
            elEmail.innerHTML=response.email
            if(elPhone!=null)
                elPhone.innerHTML=response.phone
        }).catch(e=>{
            console.log(e)
            switch(e.response?.data?.status?.code){
                case 'ERR_INVALID_FIELDS':
                    let details = e.response.data.details[0]
                    if(details.code==='string.empty')
                        setShowError(i18n.t('errors.required_field').replace('{1}', i18n.t(`models.user.fields.${details.field}`)))
                    else if(['number.base', 'string.pattern.base', 'date.base', 'any.base', 'string.email'].includes(details.code))
                        setShowError(i18n.t('errors.invalid_field').replace('{1}', i18n.t(`models.user.fields.${details.field}`)))
                    else
                        setShowError(i18n.t('errors.unknown'))
                    break;
                case 'ERR_ALREADY_EXISTS':
                    let details2 = e.response.data.details
                    setShowError(`${i18n.t(`models.user.fields.${details2.field}`)} ${details2.value} `+i18n.t('errors.already_in_use'))
                    break;
                default:
                    setShowError(i18n.t('errors.unknown'))
                    break;
            }
            setLoading(false)
            // setEditing(false)
        })
    }

    const handleSubmitDelete = async () => {
        let func = iminioBackend.delete_admin_user
        if(userData.is_deleted===true)
            func = iminioBackend.restore_admin_user
        setLoading(true)
        await func(userData.id).then(response=>{
            setLoading(false)
            setDeleting(false)
            reloadList()
        }).catch(e=>{
            console.log(e)
            setLoading(false)
            setEditing(false)
        })
    }

    const handleCancelEdit = () => {
        emailField.current.value = lastUserData.email
        firstnameField.current.value = lastUserData.first_name
        lastnameField.current.value = lastUserData.last_name
        phoneField.current.value = lastUserData.phone
        setEditing(false)
    }

    // const handleResetPassword = () => {
    //     console.log("Reseting Password")
    // }

    const goToAssignedCondominia = (admin_id) => {
        localStorage.setItem('prefilter', JSON.stringify({managed_by_id: admin_id}))
        setTimeout(() => {
            changeView('condominium')
        }, 150);
    }

    return <>
        <Row>
            <Col xs={12} md={5} className="justify-content-start pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column xs="2">
                        <span className="fg-orange"><b>Nome:</b></span>
                    </Form.Label>
                    <Col xs="1"></Col>
                    <Col xs="9">
                        <Form.Control plaintext={!isEditing && !isLoading} readOnly={!isEditing && !isLoading} ref={firstnameField} defaultValue={userData.first_name}/>
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} md={5} className="justify-content-start pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <   Form.Label column xs="2">
                        <span className="fg-orange"><b>Cognome:</b></span>
                    </Form.Label>
                    <Col xs="1"></Col>
                    <Col xs="9">
                        <Form.Control plaintext={!isEditing && !isLoading} readOnly={!isEditing && !isLoading} ref={lastnameField} defaultValue={userData.last_name}/>
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} md={5} className="justify-content-start pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column xs="2">
                        <span className="fg-orange"><b>E-mail:</b></span>
                    </Form.Label>
                    <Col xs="1"></Col>
                    <Col xs="9">
                        <Form.Control plaintext={!isEditing && !isLoading} readOnly={!isEditing && !isLoading} ref={emailField} defaultValue={userData.email}/>
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} md={5} className="justify-content-start pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column xs="2">
                        <span className="fg-orange"><b>Telefono:</b></span>
                    </Form.Label>
                    <Col xs="1"></Col>
                    <Col xs="9">
                        <Form.Control plaintext={!isEditing && !isLoading} readOnly={!isEditing && !isLoading} ref={phoneField} defaultValue={userData.phone}/>
                    </Col>
                </Form.Group>
            </Col>
            {/* <Col xs={12} md={3} className="justify-content-start pe-4">
                <Row className="justify-content-start">
                    <Button className={`px-2 corner-round bg-orange fg-white`} variant="orange" disabled={!isEditing && !isLoading} onClick={()=>{handleResetPassword()}}>
                        <i className="mdi mdi-key me-2"></i>
                        Reimpostare Password
                    </Button>
                </Row>
            </Col> */}
            <Col xs={12} md={5} className="justify-content-start pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column xs="2">
                        <span className="fg-orange"><b>Note:</b></span>
                    </Form.Label>
                    <Col xs="1"></Col>
                    <Col xs="9">
                        <Form.Control ref={notesField} plaintext={!isEditing && !isLoading} readOnly={!isEditing && !isLoading} as="textarea" rows="4" defaultValue={userData.notes} />
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={7} sm={6} md={3} className="justify-content-start mb-2">
                <Row className="justify-content-start">
                    <Button className={`px-2 corner-round bg-orange fg-white`} variant="orange" size="sm" disabled={isEditing} onClick={()=>{goToAssignedCondominia(userData.id)}}>
                        Condomini Associati
                    </Button>
                </Row>
            </Col>
            <Row className="justify-content-end">
                        {
                        !showMessage || showMessage.length===0 ? '' :
                        <div className="iminio-error-container bg-green fg-white justify-content-center px-4 text-9 iminio-border-round-force me-3">
                            <i className="mdi mdi-check-circle me-2"></i>
                            {showMessage}
                        </div>
                        }
                        {
                        !showError || showError.length===0 ? '' :
                        <div className="iminio-error-container bg-red fg-white justify-content-center px-4 text-9 iminio-border-round-force me-3">
                            <i className="mdi mdi-alert-circle me-2"></i>
                            {showError}
                        </div>
                        }
            </Row>
            <Col xs={12} className="d-flex justify-content-end align-items-center mt-3">
                {
                    !isEditing ? '' :
                    <>
                        <Button className={`px-4 me-2 corner-round bg-gray-darker fg-text`} variant="orange" disabled={isLoading} onClick={()=>{handleCancelEdit()}} size={'sm'}>
                            <i className="mdi mdi-close me-2"></i>
                            Cancella
                        </Button>
                        <Button className={`px-5 corner-round bg-orange fg-white`} variant="orange" disabled={isLoading} onClick={()=>{handleSubmitEdit()}} size={'sm'}>
                            <i className="mdi mdi-content-save me-2"></i>
                            Salva
                        </Button>
                    </>
                }
                {
                    isEditing || isDeleting ? '' :
                    <>
                        <Button className={`px-3 corner-round bg-orange fg-white`} variant="orange" onClick={()=>{setEditing(true)}} size={'sm'}>
                            <i className="mdi mdi-square-edit-outline me-2"></i>
                            Modifica
                        </Button>
                        <div className="divider-v mx-4"></div>
                        {
                            userData.is_deleted===false ? 
                                <Button className={`px-3 corner-round bg-red fg-white`} variant="red" onClick={()=>{setDeleting(true)}} size={'sm'}>
                                    <i className="mdi mdi-delete me-2"></i>
                                    Eliminare
                                </Button>
                            :
                                <Button className={`px-3 corner-round bg-green fg-white`} variant="red" onClick={()=>{setDeleting(true)}} size={'sm'}>
                                    <i className="mdi mdi-delete-restore me-2"></i>
                                    Ripristinare
                                </Button>
                        }
                    </>
                }
                {
                    !isDeleting ? '' :
                    <>
                        Vuoi {userData.is_deleted===false?'eliminare':'rirpistinare'} questo amministratore?
                        <Button className={`ms-3 px-3 corner-round bg-orange fg-white`} variant="orange" onClick={()=>{setDeleting(false)}} size={'sm'}>
                            No
                        </Button>
                        <div className="divider-v mx-4"></div>
                        <Button className={`px-3 corner-round ${userData.is_deleted===false?'bg-red':'bg-green'} fg-white`} variant="red" onClick={()=>{handleSubmitDelete()}} size={'sm'}>
                            Si
                            <i className="mdi mdi-delete ms-2"></i>
                        </Button>
                    </>
                }
            </Col>
        </Row>
    </>;
}

export default EditAdminForm